module.exports = {
    "Empty": `\u{7A7A}`
};


//# sourceMappingURL=zh-CN.main.js.map
